import React, { useState, useEffect } from 'react';
import useBoundingclientrectRef from "@rooks/use-boundingclientrect-ref"
import classnames from 'classnames';
import { YEARS } from '../tool/data';

export default (props) => {
  const {
    x,
    y,
    width,
    height,
    color,
    borderColor,
    className = 'node',
    label,
    node,
    icon,
    scenarioId,
    yearId,
    onChange = () => {},
    onChangeData = () => {},
    onToggle = () => {},
    editableMax,
    editableMin,
    editMode,
    editingDisabled,
    expandedNodeIds,
    ...rest
  } = props;

  const [messageRef, messageBCR] = useBoundingclientrectRef();

  // const [expanded, setExpanded] = useState(false);
  const [value, setValue] = useState(node.incomingTotalCO2[scenarioId][yearId]);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  let SVGComponent;
  if (icon) {
    SVGComponent = require(`#/svg/${icon}.svg`).default;
  }

  const canEdit = yearId === YEARS.length - 1;
  const canReset = editableMin !== value;
  const isExpanded = canEdit && expandedNodeIds.indexOf(node.id) > -1;

  useEffect(() => {
    setValue(node.incomingTotalCO2[scenarioId][yearId]);
    if (!canEdit) {
      // setExpanded(false);
    }
  }, [node, scenarioId, yearId]);

  const clickHandler = () => {
    console.log(node.id);
    if (node.editable && canEdit) {
      onToggle(node.id);
    }
    if (!!node.tooltip) {
      setTooltipOpen(!tooltipOpen);
    }
  };

  const messageHeight = messageBCR ? messageBCR.height : 0;

  return (
    <div
      {...rest}
      style={{
        position: 'absolute',
        left: `${x}px`,
        top: `${y}px`,
        width: `${width}px`,
        backgroundColor: color,
        borderBottomColor: borderColor,
        fontSize: '5px',
        height: `${height}px`,
        ...(isExpanded
          ? {
              height: `${messageHeight + (canReset ? 152 : 115)}px`,
            }
          : {}),
        // ...(!canEdit
        //   ? {
        //       transition: 'none',
        //     }
        //   : {}),
      }}
      className={classnames(className, 'vis-node', {
        editable: node.editable,
        expanded: isExpanded,
        editmode: editMode,
        hasTooltip: !!node.tooltip,
      })}
      onClick={!('ontouchstart' in window) ? clickHandler : null}
      onTouchStart={!!('ontouchstart' in window) ? clickHandler : null}
    >
      {!node.editable && (
        <>
          {SVGComponent && <SVGComponent />}
          <span className="vis-node__label">{label}</span>
          {node.tooltip && (<div className="vis-node__tooltip-toggle">i</div>)}
          {node.tooltip && (<div className={classnames("vis-node__tooltip",{
            open: tooltipOpen,
          })}>
            {node.tooltip}
          </div>)}

        </>
      )}

      {node.editable && (
        <>
          <div
            className="vis-node__title"
            style={{
              height: `${height - 2}px`,
              cursor: canEdit ? 'pointer' : 'default',
            }}
          >
            {SVGComponent && <SVGComponent />}
            <span className="vis-node__label" style={{
                marginLeft: 4,
                marginRight: 16,
                flex: 1,
                justifyContent: "center",
            }}>
              {label}
            </span>
            <div
              className={classnames('vis-node__tick', {
                active: isExpanded,
              })}
              style={{
                opacity: canEdit ? 1 : 0,
              }}
            />
          </div>
          <div
            className="vis-node__tweak-area"
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className="vis-node__message"
              ref={messageRef}
            >
              {node.editableMessage}
            </div>
            <div className="vis-node__value">{value.toFixed(3)} Gt</div>
            <div
              className="vis-node__slider-wrapper"
              style={{
                opacity: !editingDisabled ? 1 : 0.3,
                pointerEvents: !editingDisabled ? 'auto' : 'none',
              }}
            >
              <input
                type="range"
                className="slider"
                value={value}
                min={editableMin}
                max={editableMax}
                disabled={editingDisabled}
                step="0.001"
                onChange={(e) => setValue(parseFloat(e.target.value))}
                onMouseUp={(e) => onChangeData(node.editableRel, value)}
                onTouchStartCapture={(e) => {e.stopPropagation();}}
                onMouseDownCapture={(e) => {e.stopPropagation();}}
              />
            </div>
            <div
              className="vis-node__slider-labels"
              style={{
                opacity: !editingDisabled ? 1 : 0.3,
              }}
            >
              <div>
                {editableMin.toFixed(1)}
                {editableMin !== 0 ? 'Gt' : ''}
              </div>
              <div>{editableMax.toFixed(1)}Gt</div>
            </div>

            <div
              className="vis-node__reset-value"
              style={{
                opacity: canReset ? 1 : 0,
              }}
              onClick={() => {
                setValue(parseFloat(editableMin));
                onChangeData(node.editableRel, editableMin);
              }}
            >
              Reset value
            </div>
          </div>
        </>
      )}
      {editMode && (
        <div className="vis-node__infopanel">
          <div>
            {node.incomingTotalCO2[scenarioId][yearId].toFixed(4)} inCO2
          </div>
          <div>
            {node.outgoingTotalCO2[scenarioId][yearId].toFixed(4)} outCO2
          </div>
          <div>{node.outgoing.length} Energy receivers</div>
          {node.outgoing.map((line, lineIdx) => (
            <React.Fragment key={lineIdx}>
              <div key={`c-${lineIdx}`}>
                <span className="vis-node__tweaker-label">{line.rel}:</span>
                <span
                  className="vis-node__tweaker-button"
                  onClick={(e) =>
                    onChange(
                      'outgoing',
                      'turn',
                      line.series.turn[scenarioId][yearId],
                      lineIdx,
                      scenarioId,
                      yearId,
                      true,
                    )
                  }
                >
                  {'<->'}
                </span>
                <input
                  type="range"
                  value={`${line.series.turn[scenarioId][yearId]}`}
                  min="0"
                  max="100"
                  step="0.5"
                  style={{
                    width: 200,
                  }}
                  onChange={(e) =>
                    onChange(
                      'outgoing',
                      'turn',
                      parseFloat(e.target.value),
                      lineIdx,
                      scenarioId,
                      yearId,
                    )
                  }
                />
                {Math.round(line.turn.toFixed(1))}
              </div>
              <div key={`d-${lineIdx}`}>
                <span className="vis-node__tweaker-label">r:</span>
                <span
                  className="vis-node__tweaker-button"
                  onClick={(e) =>
                    onChange(
                      'outgoing',
                      'r',
                      line.series.r[scenarioId][yearId],
                      lineIdx,
                      scenarioId,
                      yearId,
                      true,
                    )
                  }
                >
                  {'<->'}
                </span>
                <input
                  type="range"
                  value={`${line.series.r[scenarioId][yearId]}`}
                  min="0"
                  max="100"
                  step="0.5"
                  style={{
                    width: 200,
                  }}
                  onChange={(e) =>
                    onChange(
                      'outgoing',
                      'r',
                      parseFloat(e.target.value),
                      lineIdx,
                      scenarioId,
                      yearId,
                    )
                  }
                />
                {Math.round(line.r.toFixed(1))}
              </div>
            </React.Fragment>
          ))}
          <div>{node.outgoingCO2.length} CO2 receivers</div>
          {node.outgoingCO2.map((line, lineIdx) => (
            <React.Fragment key={lineIdx}>
              <div key={`a-${lineIdx}`}>
                <span className="vis-node__tweaker-label">{line.rel}:</span>
                <span
                  className="vis-node__tweaker-button"
                  onClick={(e) =>
                    onChange(
                      'outgoingCO2',
                      'turn',
                      line.series.turn[scenarioId][yearId],
                      lineIdx,
                      scenarioId,
                      yearId,
                      true,
                    )
                  }
                >
                  {'<->'}
                </span>
                <input
                  type="range"
                  value={`${line.series.turn[scenarioId][yearId]}`}
                  min="0"
                  max="100"
                  step="0.5"
                  style={{
                    width: 200,
                  }}
                  onChange={(e) =>
                    onChange(
                      'outgoingCO2',
                      'turn',
                      parseFloat(e.target.value),
                      lineIdx,
                      scenarioId,
                      yearId,
                    )
                  }
                />
                {Math.round(line.turn.toFixed(1))}
              </div>
              <div key={`b-${lineIdx}`}>
                <span className="vis-node__tweaker-label">r:</span>
                <span
                  className="vis-node__tweaker-button"
                  onClick={(e) =>
                    onChange(
                      'outgoingCO2',
                      'r',
                      line.series.r[scenarioId][yearId],
                      lineIdx,
                      scenarioId,
                      yearId,
                      true,
                    )
                  }
                >
                  {'<->'}
                </span>
                <input
                  type="range"
                  value={`${line.series.r[scenarioId][yearId]}`}
                  min="0"
                  max="100"
                  step="0.5"
                  style={{
                    width: 200,
                  }}
                  onChange={(e) =>
                    onChange(
                      'outgoingCO2',
                      'r',
                      parseFloat(e.target.value),
                      lineIdx,
                      scenarioId,
                      yearId,
                    )
                  }
                />
                {Math.round(line.r.toFixed(1))}
              </div>
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};
